var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    width: 21,
    height: 21,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24507 14.2326C9.34125 14.3179 9.48607 14.3197 9.58436 14.2346C11.728 12.3747 13.6821 10.424 16.0136 8.45553C16.2148 8.28563 16.3347 8.04818 16.3514 7.78632C16.4029 6.97249 15.4338 6.43956 14.7752 6.98433C12.7804 8.63178 11.1219 10.1261 9.57499 11.6705C9.27099 11.3668 8.86431 10.9324 8.36248 10.3749C7.97452 9.94402 7.27433 9.86947 6.80333 10.3347C6.38963 10.7431 6.36989 11.3986 6.75801 11.8273C7.69478 12.8612 8.2829 13.3772 9.24507 14.2326Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21086 18.8559C7.49622 21.409 12.4669 21.6098 15.9091 19.2724C18.8667 17.2641 20.6015 13.4025 20.2877 9.82294C20.1006 4.50213 16.6433 1.18935 10.9569 0.930491C9.28443 0.851229 7.65911 1.26493 6.2261 2.10646C3.83233 3.23319 1.85298 5.26925 0.959794 7.76614C-0.441632 11.6838 0.925472 16.3028 4.21086 18.8559ZM3.06919 6.30242C4.67608 3.29638 7.54247 1.28708 10.9335 1.44352C16.5576 1.6997 19.7831 4.92102 19.7831 10.2817C19.7831 15.1549 15.8185 19.1196 10.9452 19.1196C4.23054 19.1196 0.0769612 11.9006 3.06919 6.30242Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValid);
export default __webpack_public_path__ + "static/media/valid.0ad462af510dd011237774e4332493ee.svg";
export { ForwardRef as ReactComponent };